module.exports = __webpack_public_path__ + "img/headPiece.c592e3eb.png";